import { financeListingVideos, tabOptions } from "@/fixtures/video/finance/fixtures";
import {
  peopleVideos,
  topicVideos,
  type VideoCardData,
} from "@/fixtures/video/home/fixtures";

/**
 * The video category listings, keyed by URL slug.
 *
 * `/video/finance`, `/video/people` and `/video/topics` were three page files
 * that differed only in which fixture they imported and what they typed into
 * `title` — same shell, same grid, same sidebar, same loading sentinel. QA
 * asked for them to be one route, so the per-category data lives here and
 * `app/[locale]/(public)/video/[slug]` is the single page.
 *
 * `tabs` is optional: when a category has no authored tab list, the listing
 * derives one from the rows themselves. A hand-written list can offer a filter
 * that matches nothing, which is how the estate-price region chips went wrong.
 */
export type VideoCategory = {
  slug: string;
  title: string;
  videos: VideoCardData[];
  tabs?: readonly string[];
};

export const VIDEO_CATEGORIES: Record<string, VideoCategory> = {
  finance: {
    slug: "finance",
    title: "財經視頻",
    videos: financeListingVideos,
    tabs: tabOptions,
  },
  people: {
    slug: "people",
    title: "人訪視頻",
    videos: peopleVideos,
  },
  topics: {
    slug: "topics",
    title: "專題視頻",
    videos: topicVideos,
  },
};

export const VIDEO_CATEGORY_SLUGS = Object.keys(VIDEO_CATEGORIES);

export function getVideoCategory(slug: string): VideoCategory | undefined {
  return VIDEO_CATEGORIES[slug];
}

/** Authored tabs when there are any, otherwise the categories present in the rows. */
export function videoCategoryTabs(category: VideoCategory): readonly string[] {
  return (
    category.tabs ?? ["全部", ...new Set(category.videos.map((v) => v.category))]
  );
}
